import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { StorageService } from '../storage.service';
import { TotemService } from '../totem.service';
@Component({
  selector: 'app-donde-quiero-ir',
  templateUrl: './donde-quiero-ir.component.html',
  styleUrls: ['./donde-quiero-ir.component.css']
})
export class DondeQuieroIrComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  
  KEY = 'dondeVoy';
  
  tiendas = [];
  subcategorias = [];
  tiendasSinfiltro = [];
  tiendasCargadas = false;
  textoBusqueda: string;
  autoCompletador: boolean = false;
  // 2
  public actual: string = '';
  constructor(private formBuilder: FormBuilder, private localStorage: StorageService, private router: Router,
    public totemService: TotemService) {
          // 3
    this.actual = this.totemService.actualLanguage;
    }


  ngOnInit() {
    // this.obtenerTiendas();
    this.registerForm = this.formBuilder.group({
      dondeEstas: ['', Validators.required],
      dondeQuieresIr: ['', Validators.required],
    });
  }
  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  onSubmit() {

    
    const resultadoLocal = this.localStorage.getNodosRuta();
    console.log('resultado entregado', resultadoLocal);
    if(!resultadoLocal || !resultadoLocal.totemInicio) {alert("indique su inicio");return};
    if(!resultadoLocal.destino) {alert("indique su destino");return};
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.controls['dondeQuieresIr'].invalid) {
      return;
    }
    // display form values on success
    if (resultadoLocal.tipoDestino === 'servicios') {
      this.router.navigate([`mapa/${resultadoLocal.totemInicio || 0}/0/${resultadoLocal.tipoDestino}/${resultadoLocal.destino}`]);
      return;
    }
    this.router.navigate([`mapa/${resultadoLocal.totemInicio || 0}/${resultadoLocal.destino}/${resultadoLocal.tipoDestino}/0`]);
  }

  onReset() {
    this.submitted = false;
    this.registerForm.reset();
  }
  // 4
  changeLanguage(language: any) {
    this.actual = language;
    this.totemService.changeLanguage(language);
  }
  getTranslation(key: string) {
    const word = this.totemService.getTranslation(key);
    if (word){
      return word[0].texto_descripcion;
    }
  }

}
